import React from 'react';
import styles from './FormFeedback.module.css';

const FormFeedback = ({ error, success }) => (
    <>
        {error && <p className={styles.errorMessage}>{error}</p>}
        {success && <p className={styles.successMessage}>{success}</p>}
    </>
);

export default FormFeedback;
